import { createRouter, createWebHistory } from "vue-router";

const router = createRouter({
  history: createWebHistory("/"),
  routes: [
    {
      path: "/",
      name: "Home",
      component: () => import("../views/HomeView.vue"),
    },
    {
      path: "/about-us",
      name: "AboutUs",
      component: () => import("../views/AboutUs.vue"),
    },

    {
      path: "/features",
      name: "Features",
      component: () => import("../views/FeaturesView.vue"),
    },
    {
      path: "/pricing",
      name: "Pricing",
      component: () => import("../views/PricingView.vue"),
    },
    {
      path: "/partners",
      name: "Partners",
      component: () => import("../views/PartnersView.vue"),
    },
    {
      path: "/contact-us",
      name: "ContactUs",
      component: () => import("../views/ContactUs.vue"),
    },
    {
      path: "/slide",
      name: "Slide",
      component: () => import("../views/SlideView.vue"),
    },
    {
      path: "/get-started",
      name: "GetStarted",
      component: () => import("../views/GetStarted.vue"),
    },

    {
      path: "/terms-and-conditions",
      name: "TermsAndConditions",
      component: () => import("../views/TermsAndConditions.vue"),
    },

    {
      path: "/privacy-policy",
      name: "PrivacyPolicy",
      component: () => import("../views/PrivacyPolicy.vue"),
    },

    {
      path: "/blog/:slug?",
      name: "Blog",
      component: () => import("../views/BlogContent.vue"),
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    // Always scroll to top when navigating to a new page
    if (savedPosition) {
      return savedPosition; // Restore scroll position if using browser's forward/back buttons
    } else {
      return { left: 0, top: 0 }; // Scroll to top-left of the page
    }
  },
});

export default router;
